import React from 'react';
import '../HomePage.css';
import { useAuth } from '../AuthContext';

const UserExpertSuggestions = () => {
    const { userData } = useAuth();

    return (
        <div className="expert-suggestion-container">
            <h2 className="expert-suggestion-heading">Welcome, {userData.name}!</h2>
            <p className="expert-intro">
                Your upcoming meeting with an expert is a valuable opportunity to gain insights, guidance, and actionable advice. Here’s how you can prepare and make the most out of it.
            </p>

            <section className="expert-suggestion-section">
                <h3 className="expert-suggestion-subheading">1. Prepare Ahead of Time</h3>
                <p className="expert-suggestion-text">
                    Preparation is key to a productive meeting. Here are some steps to ensure you’re ready:
                </p>
                <ul className="expert-suggestion-list">
                    <li>Research the expert’s background and areas of expertise.</li>
                    <li>List down specific questions or challenges you’d like their input on.</li>
                    <li>Set clear goals for what you want to achieve from the meeting.</li>
                </ul>
            </section>

            <section className="expert-suggestion-section">
                <h3 className="expert-suggestion-subheading">2. Be Open and Engaged</h3>
                <p className="expert-suggestion-text">
                    Engagement is essential for a meaningful interaction. Here’s how you can stay active during the meeting:
                </p>
                <ul className="expert-suggestion-list">
                    <li>Listen attentively to their advice and ask follow-up questions to clarify your doubts.</li>
                    <li>Be honest about your challenges and areas where you need help.</li>
                    <li>Take notes during the meeting to remember key takeaways and suggestions.</li>
                </ul>
            </section>

            <section className="expert-suggestion-section">
                <h3 className="expert-suggestion-subheading">3. Focus on Actionable Advice</h3>
                <p className="expert-suggestion-text">
                    Use the expert’s time effectively by focusing on actionable strategies:
                </p>
                <ul className="expert-suggestion-list">
                    <li>Ask for specific steps you can take to overcome challenges or achieve your goals.</li>
                    <li>Seek examples or case studies that are relevant to your situation.</li>
                    <li>Request feedback on your current plans or strategies to ensure they are on the right track.</li>
                </ul>
            </section>

            <section className="expert-suggestion-section">
                <h3 className="expert-suggestion-subheading">4. Reflect and Follow Up</h3>
                <p className="expert-suggestion-text">
                    Post-meeting actions are just as important as the meeting itself. Here’s what to do:
                </p>
                <ul className="expert-suggestion-list">
                    <li>Review your notes and identify the key points you want to implement.</li>
                    <li>Take immediate action on any advice or tasks discussed during the meeting.</li>
                    <li>Follow up with the expert to update them on your progress or ask further questions if needed.</li>
                </ul>
            </section>

            <section className="expert-suggestion-section">
                <h3 className="expert-suggestion-subheading">5. Build a Connection</h3>
                <p className="expert-suggestion-text">
                    Establishing a long-term connection with the expert can lead to future opportunities:
                </p>
                <ul className="expert-suggestion-list">
                    <li>Express gratitude for their time and insights by sending a thank-you note.</li>
                    <li>Communicate only through our website and no personal communication is encouraged.</li>
                </ul>
            </section>
        </div>
    );
};

export default UserExpertSuggestions;
